import React from 'react';
import Select from 'react-select';
import styles from '../HomePageForm/HomePageForm.module.sass';
import useSchools from '../../hooks/useSchools';

export default function AdminSchoolInput({ school }) {
  const schools = useSchools()
  // Preserve existing query params (e.g. the selected season ?year=) when
  // switching schools, so the season picker selection survives the reload.
  const schoolHandler = (opt) => {
    const params = new URLSearchParams(window.location.search);
    params.set('school_id', opt.value);
    window.location = `${window.location.pathname}?${params.toString()}`;
  };

  return (
    <Select
      id="school-input"
      defaultValue={school}
      options={[{ id: 'all', name: 'All' }, ...schools].map((selectSchool) => (
        ({ value: selectSchool.id, label: selectSchool.name })
      ))}
      className={styles.schoolInput}
      onChange={schoolHandler}
    />
  )
};
